<template>
  <modal name="product-review-modal" height="auto" width="590px" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('product-review-modal')"  alt="">
    </div>
    <div class="modal-form">
      <div class="rate" v-if="!review_id && !answer_user_id">
        <div class="rating-area">
          <input type="radio" v-model="rate" id="star-1" name="rating" value="5">
          <label for="star-1" title="Оценка «1»"></label>
          <input type="radio" v-model="rate" id="star-2" name="rating" value="4">
          <label for="star-2" title="Оценка «2»"></label>
          <input type="radio" v-model="rate" id="star-3" name="rating" value="3">
          <label for="star-3" title="Оценка «3»"></label>
          <input type="radio" v-model="rate" id="star-4" name="rating" value="2">
          <label for="star-4" title="Оценка «4»"></label>
          <input type="radio" v-model="rate" id="star-5" name="rating" value="1">
          <label for="star-5" title="Оценка «5»"></label>
        </div>
      </div>
      <h4 v-if="!review_id && !answer_user_id">Преимущества</h4>
      <div v-if="!review_id && !answer_user_id" class="input-block">
        <input type="text"
               v-model="benefits"
               name="benefits"
        >
      </div>
      <h4 v-if="!review_id && !answer_user_id">Недостатки</h4>
      <div v-if="!review_id && !answer_user_id" class="input-block">
        <input type="text"
               v-model="shortcomings"
               name="shortcomings"
        >
      </div>
      <h4>Комментарий*</h4>
       <textarea
           type="text"
           v-model="comment"
           name="comment"
           data-vv-validate-on="blur"
           data-vv-as="Комментарий"
           v-validate="'required'"
       >
            </textarea>

      <div class="upload-photo-container">
        <div class="upload-image-preview-block" v-for="(image, idx) in upload_images" :key="'image-' + idx">
          <img :src="image.url" alt="" :class="{'upload-preview': image.upload}" class="upload-image-preview">
          <div class="delete-photo" v-if="!image.upload" @click="deletePhoto(image.id)">
            <img src="../../assets/icons/close.svg"  alt="">
          </div>
          <div class="upload-file-status" v-if="image.upload">
            <div class="loader-block"><app-loader :loaderHeight="20" :loaderWidth="20"></app-loader></div>
          </div>
        </div>
      </div>
      <div @click="fileInput" class="upload-photo">
        <img src="../../assets/icons/chat/paperclip.svg"  alt="" class="add">
        Загрузить фото
      </div>
      <input type="file" ref="file" hidden @change="onFileChange">

      <div class="btn">
        <button @click="send()">Сохранить</button>
      </div>
    </div>
  </modal>
</template>

<script>

import AppLoader from "@/components/app-loader";

export default {
  name: "product-rate",
  components: { AppLoader },
  data: ()=> ({
    rate: '',
    comment: '',
    item_id: '',
    review_id: '',
    answer_user_id: '',
    benefits: '',
    shortcomings: '',
    images: [],
    image: '',
    upload_images: []
  }),
  methods: {
    open(product_id, review_id = null, answer_user_id = null){
      this.clear();
      this.item_id = product_id;
      if (review_id && answer_user_id) {
        this.review_id = review_id;
        this.answer_user_id = answer_user_id;
      }

      this.$modal.show('product-review-modal');
    },
    send() {
      let images = [];

      for(let key in this.images) {
        images.push(this.images[key].url);
      }
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$http.post('/create-product-review', {
            token: localStorage.getItem('token'),
            rate: this.rate,
            review: this.comment,
            product_id: this.item_id,
            review_id: this.review_id,
            answer_user_id: this.answer_user_id,
            benefits: this.benefits,
            shortcomings: this.shortcomings,
            images: images
          }).then(({data}) => {
            if (data.success) {
              this.$toast.success('Отзыв успешно сохранен!');
              this.$modal.hide('product-review-modal');
              this.$emit('send', {
                rate: data.rate,
                rate_count: data.rate_count,
                count_reviews: data.count_reviews,
                reviews: data.reviews
              });
              this.clear();
            }
          })
              .catch((error) => {
                console.log(error)
                this.$toast.error('Ошибка!');
              })
        }
      })
    },
    onFileChange(e) {
      this.image = e.target.files[0];
      let id = this.upload_images.length;
      this.upload_images.push({
        url: URL.createObjectURL(this.image),
        upload: true,
        id: id
      });
      let formData = new FormData();
      formData.append('image', this.image);
      formData.append('token', localStorage.getItem('token'));
      this.$http.post( '/upload-product-review-image',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then((response) => {
        if (response.data.url) {
          for (let key in this.upload_images) {
            if (this.upload_images[key].id == id) {
              this.upload_images[key].upload = false;
            }
          }

          this.images.push({
            url: response.data.url,
            id: id
          });
        }
      }).catch((error) => {
        if (error.response) {
          this.$toast.error(error.response.data.errors.image[0]);
          for (let key in this.upload_images) {
            if (this.upload_images[key].id == id) {
              this.upload_images.splice(key,1);
            }
          }
        }
      })
    },
    fileInput() {
      this.$refs.file.click();
    },
    deletePhoto(val) {
      for (let key in this.upload_images) {
        if (this.upload_images[key].id == val) {
          this.upload_images.splice(key,1);
        }
      }

      for (let key in this.images) {
        if (this.images[key].id == val) {
          this.images.splice(key,1);
        }
      }
    },
    clear() {
      this.rate = '';
      this.comment = '';
      this.item_id = '';
      this.review_id = '';
      this.answer_user_id = '';
      this.benefits = '';
      this.shortcomings = '';
      this.images = [];
      this.upload_images = [];
    }
  }
}
</script>

<style scoped lang="scss">

.loader-block {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.delete-photo {
  position: absolute;
  top: 0px;
  right: 6px;
  cursor: pointer;
}

.delete-photo img {
  filter: brightness(1);
  width: 16px;
  background-color: white;
  padding: 3px;
}

.upload-image-preview-block:nth-child(5n), .upload-image-preview-block:first-child {
  margin-left: 0px;
}

.upload-image-preview-block {
  position: relative;
  width: 23%;
  display: inline-block;
  margin-left: 2.67%;
  margin-top: 20px;
}

.upload-image-preview {
  width: 100%;
  border-radius: 12px;
}

.upload-photo-container {
  width: 100%;
}

.upload-preview {
  filter: blur(3px);
}

.upload-photo {
  cursor: pointer;
  font-size: 14px;
  margin-top: 14px;
}

.btn {
  margin-top: 20px;
}

.rate{
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 20%;*/
  position: relative;

  .rating-area {
    overflow: hidden;
    margin-bottom: -8px;
    z-index: 2;
  }
  .rating-area:not(:checked) > input {
    display: none;
  }
  .rating-area:not(:checked) > label {
    float: right;
    width: 26px;
    margin-right: 20px;
    margin-bottom: 30px;
    padding: 0;
    cursor: pointer;
    font-size: 12px;
    line-height: 12px;
    content: url(../../assets/icons/star-grey.svg);
  }
  .rating-area:not(:checked) > label:before {
    content: url(../../assets/icons/star-orange.svg);
  }
  .rating-area > input:checked ~ label {
    content: url(../../assets/icons/star-orange.svg);
  }
  .rating-area:not(:checked) > label:hover,
  .rating-area:not(:checked) > label:hover ~ label {
    content: url(../../assets/icons/star-orange.svg);
  }
  .rating-area > input:checked + label:hover,
  .rating-area > input:checked + label:hover ~ label,
  .rating-area > input:checked ~ label:hover,
  .rating-area > input:checked ~ label:hover ~ label,
  .rating-area > label:hover ~ input:checked ~ label {
    content: url(../../assets/icons/star-orange.svg);
  }
  .rate-area > label:active {
    position: relative;
  }
}

.progress-bar-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;

  &.title{
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
  }

  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
.rate-group{
  margin-bottom: 24px;
}
textarea{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 90px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}

input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
